import script from "./PreviewZoom.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewZoom.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewZoom.vue?vue&type=style&index=0&id=126e7bad&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-126e7bad"]])

export default __exports__